import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from 'uikit/inputs';
import { Typo } from 'uikit/content';

import PublishLocalesModalVersionStatus from './publishLocalesModalVersionStatus';

import styles from '../styles/publishLocalesModal.module.scss';

const PublishLocalesModalDropdownItem = ({
  handleCheckboxChange = () => {},
  hasUnpublishedChanges = false,
  id = null,
  isPublished = false,
  localeLabels = [],
  locale = null,
  publishedAt = null,
  selectedLocales = [],
  status = null,
  updatedAt = null,
}) => (
  <div className={styles.localeItem}>
    <Checkbox
      id={`locales-list-content-checkbox-${id}`}
      className={styles.checkbox}
      value={selectedLocales.includes(locale)}
      onChange={() => handleCheckboxChange(locale)}
      label={
        <>
          <Typo element="span" variant="s03" weight="medium">
            {localeLabels.find(({ key }) => key === locale).name}
          </Typo>
          <PublishLocalesModalVersionStatus
            publishedAt={publishedAt}
            isPublished={isPublished}
            updatedAt={updatedAt}
            status={status}
            hasUnpublishedChanges={hasUnpublishedChanges}
          />
        </>
      }
    />
  </div>
);

PublishLocalesModalDropdownItem.propTypes = {
  handleCheckboxChange: PropTypes.func,
  hasUnpublishedChanges: PropTypes.bool,
  id: PropTypes.number,
  isPublished: PropTypes.bool,
  localeLabels: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  locale: PropTypes.string,
  publishedAt: PropTypes.string,
  selectedLocales: PropTypes.arrayOf(PropTypes.string),
  status: PropTypes.oneOf(['approved', 'editing', 'in_review', 'in_translation', null]),
  updatedAt: PropTypes.string,
};

export default PublishLocalesModalDropdownItem;
